<template lang="pug" src="./custom-about-doctor.pug"></template>

<script>
export default {
  props: ['props'],
  data () {
    return {
      height: 0
    }
  },
  async mounted () {
    this.height = this.$refs.image.offsetWidth
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/custom-about-doctor/custom-about-doctor.vue